import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import NAVBARCOPY from '../NavBarCopy';
import getMyTeamMenuItems from './getMyTeamMenuItems';

const getNavBarLinks = (userData, session) => {
  if (!userData || !userData.user) {
    return [];
  }
  const { user } = userData;
  const features = user.features || {};
  const isInTeam = features.teamsEnabled;

  const navBarLinks = [
    {
      path: createURL('/dashboard/', { ut_source: 'header' }),
      name: t(NAVBARCOPY.DASHBOARD)
    },
    {
      path: createURL('/home/', { ut_source: 'header' }),
      name: t(NAVBARCOPY.MY_SURVEYS)
    },
    isInTeam && {
      name: t(NAVBARCOPY.MY_TEAM),
      menu_items: getMyTeamMenuItems(userData, session),
      key: 'team'
    },
    {
      path: createURL('/pricing/upgrade/quickview/', {
        ut_source: 'header_loggedIn'
      }),
      name: t(NAVBARCOPY.PLANS_AND_PRICING)
    }
  ];
  return navBarLinks.filter(Boolean);
};
export default getNavBarLinks;
